import { Cookies, LocalStorage } from '@stripe-internal/stripe-cookies';
export function correctCidDrift() {
    const localStorage = new LocalStorage();
    const cookies = new Cookies();
    const lsid = localStorage.get('lsid');
    const cid = cookies.get('cid');
    // If CID exists but does not match LSID, we need to correct it
    if (cid && lsid && cid !== lsid) {
        const newId = generateID();
        cookies.set('cid', newId);
        localStorage.set('lsid', newId);
        return {
            corrected: true,
            oldLsid: lsid,
            oldCid: cid,
            newId
        };
    }
    return {
        corrected: false
    };
}
// This is the same LSID generatoras the one in analytics-js/src/utils/string.ts
function generateID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // Ignore linting so I can keep it the exact same as it was, without fear
        // of subtle changes.
        /* eslint-disable */ let r = Math.random() * 16 | 0;
        let v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    /* eslint-enable */ });
}

//# sourceMappingURL=patchCids.js.map